import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IGroup } from '../typing/group.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { GroupsService } from './groups.service';

@Injectable({
    providedIn: 'root'
})
export class GroupsSelectorService {
    additionalParams: Params = {};

    constructor(private groupsService: GroupsService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        const params = { sortBy: 'id:DESC', ...this.additionalParams, ...query };
        return this.groupsService.getGroups(params).pipe(
            map(response => this.transformData(response))
        );
    }

    transformData(paginatedResponse: IPaginatedResponse<IGroup>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(group => ({
            label: group.name,
            value: group.id,
            tooltip: this.getTooltip(group),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.groupsService.getGroup(Number(optionValue)).pipe(
            filter(group => !!group),
            map(group => ({
                label: group.name as string,
                value: group.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: IGroup): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }

}
